/**
 * @package
 * @author Artem Ilinykh devsinglesly@gmail.com
 * @class EditRateData
 */
export class EditRateData {
  public rateId!: number;
  public price!: number;
}
